import { createReducer, on } from '@ngrx/store';

import { AdminOrganizationsBusinessProfilesApiActions, AdminOrganizationsBusinessProfilesPageActions, AdminOrganizationsPageActions } from '../actions';

export const adminOrganizationsBusinessProfilesPageFeatureKey = 'adminOrganizationsBusinessProfilesPage';

export interface State {
  error: any;
  pending: boolean;
}

export const initialState: State = {
  error: null,
  pending: false
};

export const reducer = createReducer(
  initialState,
  on(AdminOrganizationsPageActions.selectOrganization, (state: State) => ({ ...state, error: null, pending: true })),
  on(AdminOrganizationsBusinessProfilesPageActions.listBusinessProfilesByOrganization, (state: State) => ({ ...state, error: null, pending: true })),
  on(AdminOrganizationsBusinessProfilesApiActions.listBusinessProfilesByOrganizationSuccess, (state: State) => ({
    ...state,
    error: null,
    pending: false
  })),
  on(AdminOrganizationsBusinessProfilesApiActions.listBusinessProfilesByOrganizationFailure, (state: State, { error }) => ({ ...state, error, pending: false }))
);

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
